import { InputText } from "primereact/inputtext"
import { getFormErrorMessage, isFormFieldValid } from "../../utils/formHelper"
import { classNames } from "primereact/utils"
import { FormikValues } from "formik";

type Props = {
    disabled: boolean;
    formik: FormikValues;
    label: string;
    value: string;
}

export const FormInputText = (props: Props) => {
    const { disabled, formik, label, value } = props;

    return (
        <div className="field">
            <span className="p-float-label">
                <InputText id={value} name={value} value={formik.values[value]} onChange={formik.handleChange} 
                    disabled={disabled} className={classNames("w-full", { 'p-invalid': isFormFieldValid(value, formik) })} />
                <label htmlFor={value} className={classNames({ 'p-error': isFormFieldValid(value, formik) })}>{label}</label>
            </span>
            {getFormErrorMessage(value, formik)}
        </div>
    )
}